<div class="btn-dm-toolbar" [ngClass]="{ readonly: disabled }">
    @if (standingData) {
        @if (!disabled) {
            <button class="btn btn-success buttonspace" (click)="addEntity()">
                {{ 'datamanagement.dataStructures.addThirdPartiesBtn' | transloco }}
            </button>
        }
    } @else {
        <div><i class="fas fa-circle-notch fa-spin me-2"></i> {{ 'datamanagement.dataStructures.fetchingThirdParties' | transloco }}</div>
    }
</div>

@if (dataStructuresModel && standingData) {
    <div class="entities-display">
        @for (entity of dataStructuresModel.entities; track entity) {
            <div class="entity-detail col-12 col-xxl-6">
                <entity-detail
                    #entityDetail
                    [entityModel]="entity"
                    [standingData]="standingData"
                    (entityDeleted)="deleteEntity($event)"
                    [disabled]="disabled"
                >
                </entity-detail>
            </div>
        }
    </div>
} @else {
    <div class="fancy-loader"></div>
}
